import React from "react";

import { HISTORY_TEXT } from "./catalogText";

const S = HISTORY_TEXT.strip;
const chipClass = (pressed) => `flex flex-col items-start gap-0.5 rounded-xl border bg-white px-4 py-3 text-left shadow-sm transition ${
  pressed ? "border-cyan-500 bg-cyan-50 ring-1 ring-cyan-500" : "border-[#EBECE6] hover:border-cyan-200"}`;

/** One card per cause (label, cases, trust percent, category); pressing one filters the history to it, pressing it again clears. */
export default function HistoryCauseStrip({ causes, selected, onSelect }) {
  if (!causes.length) return null;
  return (
    <section aria-label={S.label} className="mb-4 grid grid-cols-2 gap-3 md:grid-cols-3 xl:grid-cols-4">
      {causes.map((c) => {
        const pressed = selected === c.cause_id;
        return (
          <button key={c.cause_id} type="button" aria-pressed={pressed} className={chipClass(pressed)}
            onClick={() => onSelect(pressed ? "" : c.cause_id)}>
            <span className="text-sm font-bold text-[#253439] break-words">{c.cause_label}</span>
            <span className="text-xs font-semibold tabular-nums text-gray-500">{`${S.cases(c.cases)} · ${S.trust(c.percent)}`}</span>
            {c.category_label && <span className="text-[11px] uppercase tracking-wide text-cyan-700">{c.category_label}</span>}
          </button>
        );
      })}
    </section>
  );
}
